define('gigaset_recurring/components/checkout/provider/billwerk/payment/method/creditcard',[
	"jquery",
	"lodash",
	"cartware/components/_base",
	"cartware/dom/event/trigger",
	"cartware/components/PubSubHub",
	"cartware/jquery/bem",
	"card"
], function(
	$,
	_,
	Component,
	trigger,
	PubSubHub,
	BEM
) {

	function KeypressAdapter(el) {
		this.el = $(el);
		this.oldValue = this.el.val();
		this.oldCursor = this.el.get(0).selectionEnd;
		this.active = false;
		this.preventLoop = false;

		this.bindEvents();
	}

	KeypressAdapter.prototype = {
		bindEvents: function() {
			this.el.on("keydown", _.bind(this.onKeydown, this));
			this.el.on("keypress", _.bind(this.onKeypress, this));
			this.el.on("input", _.bind(this.onInput, this));
		},

		onKeydown: function(e) {
			var el = e.target;

			this.oldValue = el.value;
			this.oldCursor = el.selectionEnd;
			this.active = true;
		},

		onKeypress: function(e) {
			if (this.preventLoop) {
				return;
			}
			this.active = false;
		},

		onInput: function(e) {
			if (!this.active) {
				return;
			}

			var oldValue = this.oldValue;
			var newValue = this.el.val();
			var diff = this.difference(oldValue, newValue);
			var charCode = String.prototype.charCodeAt.call((''+diff).substring(0, 1));

			if (!_.isNaN(charCode)) {
				this.el.val(oldValue);

				this.preventLoop = true;
				var event = trigger(this.el.get(0), "keypress", {
					which: charCode
				});
				this.preventLoop = false;

				if (!event.defaultPrevented) {
					this.el.val(newValue);
				}
			}
		},

		difference: function(value1, value2) {
			var output = [];
			for(i = 0; i < value2.length; i++) {
				if(value1[i] !== value2[i]) {
					output.push(value2[i]);
				}
			}
			return output.join("");
		}
	};

	return Component.create({

		$init: function() {
			this.block = BEM.block("gigaset-recurring-payment-method-creditcard");
			this.form = this.block.getElements("form");
			this.cardContainer = this.block.getElements("card");
			this.expiryNode = this.form.find('input#expiry');

			this.card = new Card({
				form: this.form.get(0),
				container: this.cardContainer.get(0),
				formSelectors: {
					numberInput: 'input#cardNumber',
					expiryInput: 'input#expiry',
					cvcInput: 'input#cvc',
					nameInput: 'input#cardHolder'
				},
				// messages: {
				// 	validDate: 'valid\ndate', // optional - default 'valid\nthru'
				// 	monthYear: 'mm/yyyy', // optional - default 'month/year'
				// },
				//
				// // Default placeholders for rendered fields - optional
				// placeholders: {
				// 	number: '•••• •••• •••• ••••',
				// 	name: 'Full Name',
				// 	expiry: '••/••',
				// 	cvc: '•••'
				// },
			});

			new KeypressAdapter('input#cardNumber');
			new KeypressAdapter('input#expiry');
			new KeypressAdapter('input#cvc');
			new KeypressAdapter('input#cardHolder');

			trigger(this.card.$nameInput[0], "change");

			Validation.add(
				'validate-creditcard-expiration-date',
				'Please enter a value like "MM / YY" (space before and after slash).',
				function(v) {
					return Validation.get('IsEmpty').test(v) || /^\d{2}\s\/\s(\d\d){1,2}$/.test(v);
				}
			);

			this.validation = new Validation(this.form.get(0)); // global
		},

		validate: function() {
			var valid = this.validation.validate();

			valid = valid && this.expiryNode.val().match(/^\d{2}\s\/\s(\d\d){1,2}$/); // e.g. "12 / 22" or "12 / 2022"

			return valid;
		}
	});
});
